export default __webpack_public_path__ + "static/media/kenn.5f07de4f.jpeg";